import ButtonBlock from './ButtonBlock';
import { Link } from 'react-router-dom';

export default function LinkBlock({ ...props }) {
    return (
        <ButtonBlock component={Link} {...props} />
    );
}